import { AlbumResponse } from '@klubovna/api-client';
import { AlbumsQueryParams } from '../../services/albums.api.service';

export interface AlbumsState {
  albums: AlbumResponse[];
  selectedAlbum: AlbumResponse | null;
  total: number;
  page: number;
  limit: number;
  query: AlbumsQueryParams;
  hasMore: boolean;
  loading: boolean;
  loadingMore: boolean;
  error: string | null;
}

export const initialAlbumsState: AlbumsState = {
  albums: [],
  selectedAlbum: null,
  total: 0,
  page: 1,
  limit: 9,
  query: {
    page: 1,
    limit: 9,
    sortBy: 'eventDate',
    sortOrder: 'DESC',
  },
  hasMore: false,
  loading: false,
  loadingMore: false,
  error: null,
};
